// extracted by mini-css-extract-plugin
export var root = "Section-module--root--1A5zu";
export var title = "Section-module--title--mkp6M";
export var separator = "Section-module--separator--Fouy5";